import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBirthdayCake, faPen } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

import LeftSidebar from "../../Leftsidebar/Leftsidebar";
import Avatar from "../../../Components/Avatar/Avatar";
import EditProfileForm from "./EditProfileForm";
import ProfileBio from "./ProfileBio";
import "./UsersProfile.css";

const UserProfile = ({ slideIn, handleSlideIn }) => {
  const { id } = useParams();
  const users = useSelector((state) => state.usersReducer);
  const currentProfile = users.filter((user) => user._id === id)[0];
  const currentUser = useSelector((state) => state.currentUserReducer);
  const [Switch, setSwitch] = useState(false);
  // console.log(id);
  // console.log(currentProfile?.file);
  return (
    <div className="home-container-1">
      <LeftSidebar slideIn={slideIn} handleSlideIn={handleSlideIn} />
      <div className="home-container-user-2">
        <section>
          <div className="user-details-container">
            <div className="user-details">
              {/* <Avatar
                backgroundColor="purple"
                color="white"
                fontSize="50px"
                px="40px"
                py="55px"
              >
                {currentProfile?.name.charAt(0).toUpperCase()}
              </Avatar> */}
              {/* Conditionally render the profile picture or avatar */}
              {currentProfile?.file ? (
                <img
                  src={`http://localhost:5000/uploads/${currentProfile.file}`}
                  // src={`https://stackoverflowclone-backend-nh9c.onrender.com/uploads/${currentProfile.file}`}
                  alt={currentProfile?.name}
                  className="profile-picture"
                  // style={{ width: "200px", height: "200px" }}
                />
              ) : (
                <Avatar
                  backgroundColor="purple"
                  color="white"
                  fontSize="50px"
                  px="40px"
                  py="55px"
                >
                  {currentProfile?.name.charAt(0).toUpperCase()}
                </Avatar>
              )}
              <div className="user-name">
                <h1>{currentProfile?.name}</h1>
                <p>
                  <FontAwesomeIcon icon={faBirthdayCake} /> Joined{" "}
                  {moment(currentProfile?.joinedOn).fromNow()}
                </p>
              </div>
            </div>
            {currentUser?.result._id === id && (
              <button
                type="button"
                onClick={() => setSwitch(true)}
                className="edit-profile-btn"
              >
                <FontAwesomeIcon icon={faPen} /> Edit Profile
              </button>
            )}
          </div>
          <>
            {Switch ? (
              <EditProfileForm
                currentUser={currentUser}
                setSwitch={setSwitch}
              />
            ) : (
              <ProfileBio currentProfile={currentProfile} />
            )}
          </>
        </section>
      </div>
    </div>
  );
};

export default UserProfile;
